import React, { useEffect, useRef, useState } from 'react'
import SliderContent from './SliderContent'
import useWindowDimentions from '../hooks/useWindowDimentions'
import nextArrow from '../icons/nextArrow.svg'
import prevArrow from '../icons/prevArrow.svg'
import { useSelector } from 'react-redux'
import { useOutletContext } from "react-router-dom";
import leftArrow from '../icons/IconSliderLeftArrow.svg'
import rightArrow from '../icons/IconSliderRightArrow.svg'
import leftArrowInactive from '../icons/IconSliderLeftArrowInactive.svg'
import rightArrowInactive from '../icons/IconSliderRightArrowInactive.svg'

export default function Slider(props) {

  const [displayCount, setDisplayCount] = useState(props.num)
  let extraSlides = props.tvData.length - displayCount
  const [movedAndMove, setMovedAndMove] = useState([0, 0])
  const [slideWrapperWidth, setSlideWrapperWidth] = useState(0)
  const [margin, setMargin] = useState(0)
  const sCWRef = useRef(null)
  const { openbar } = useOutletContext();

  const {width, height} = useWindowDimentions()

  const { active_pl_id } = useSelector(state => state.userPlaylists)


  useEffect(()=>{

    if(width < 650){
      setDisplayCount(2)
      setMargin(0.5)
    } else if (width < 992){
      setDisplayCount(3)
      setMargin(0.965)
    } else {
      setSlideWrapperWidth(openbar ? ((width-88)/displayCount)/width*100-0.6 : ((width-222)/displayCount)/width*100-0.6)
      setDisplayCount(props.num)
      setMargin(0.5)
    }
  },[width, openbar])

  useEffect(()=>{
    if (width >= 992){
        setSlideWrapperWidth(openbar ? ((width-72-16)/displayCount)/width*100-0.6 : ((width-206-16)/displayCount)/width*100-0.6)
    } else if( width >=768){
        setSlideWrapperWidth(((width-24)/displayCount)/width*100-0.6)
    } else  {
        setSlideWrapperWidth(((width-8)/displayCount)/width*100-0.6)
    }

  },[displayCount])

  let slidePlusMargin = slideWrapperWidth + margin
  let sliderContentWidth=(slideWrapperWidth + margin) * props.tvData.length - margin
  let step=slidePlusMargin

  let isDown = false
  let startX

  const [startTouch, setStartTouch] = useState()
  const [endTouch, setEndTouch] = useState()
  const [touchDown, setTouchDown] = useState(false)

  let clickHoldTimer = null;

  const handleTouchStart = (e) => {
    setTouchDown(false)
    clickHoldTimer = setTimeout(() => {
      var touch = e.touches[0] || e.changedTouches[0];
      setStartTouch(touch.pageX)
      setTouchDown(true)
    }, 100)
  }

  const handleTouchEnd = (e) => {
    clearTimeout(clickHoldTimer);
    setTouchDown(false)
    setEndTouch()
    setStartTouch()
  }

  const handleTouchMove = (e) => {
    if (!touchDown) return
    var touch = e.touches[0] || e.changedTouches[0];
    setEndTouch(touch.pageX)
    let scroll = endTouch - startTouch
    if (scroll === 0) {
      return
    } else if (scroll > 1) {
      setTouchDown(false)
      prevSlide()
    } else if (scroll < 1) {
      setTouchDown(false)
      nextSlide()
    }
  }

  const handleSCWMouseDown = (e) => {
    e.preventDefault()
    isDown = true
    startX = e.clientX
  }

  const handleSCWMouseUp = (e) => {
    isDown = false
  }
  const handleSCWMouseLeave = (e) => {
    isDown = false
  }
  const handleSCWMouseMove = (e) => {
    e.preventDefault()
    if (!isDown) return
    let endX = e.clientX
    let scroll = endX - startX
    if (scroll === 0) {
      return
    } else if (scroll > 1) {
      isDown = false
      prevSlide()
    } else if (scroll < 1) {
      isDown = false
      nextSlide()
    }
  }


  useEffect(() => {
    const element = sCWRef.current
    element.addEventListener('mousedown', handleSCWMouseDown)
    element.addEventListener('mouseup', handleSCWMouseUp)
    element.addEventListener('mouseleave', handleSCWMouseLeave)
    element.addEventListener('mousemove', handleSCWMouseMove)
    return function cleanUp() {
      element.removeEventListener('mousedown', handleSCWMouseDown)
      element.removeEventListener('mouseup', handleSCWMouseUp)
      element.removeEventListener('mouseleave', handleSCWMouseLeave)
      element.removeEventListener('mousemove', handleSCWMouseMove)
    }
  })



  useEffect(() => {
    if(props.tvData.length < displayCount){
      setMovedAndMove([0, 0])
    } else {
      let active_pl_index = props.tvData.findIndex(p=>p.id===active_pl_id)
      if(active_pl_index!==-1){
        let index = Math.min(extraSlides, active_pl_index)
        setMovedAndMove([index, index*step])
      } else {
        setMovedAndMove([0, 0])
      }
    }
  }, [props.tvData])

  const prevSlide = () => {
    if (extraSlides > 0) {
      if (movedAndMove[0] === 0) {
      } else {
        setMovedAndMove([movedAndMove[0] - 1, movedAndMove[1] - step])
      }
    }
  }

  const nextSlide = () => {
    if (extraSlides > 0) {
      if (movedAndMove[0] === extraSlides) {
      } else {

        setMovedAndMove([movedAndMove[0] + 1, movedAndMove[1] + step])
      }
    }
  }


  return (
    <>
        {
            props.showTitle &&
            <div className = "col-12 d-flex pb-2 ">
                <div className = 'text-white slide-title pt-2 ps-2 ps-md-4'>
                    {props.slideTitle ? props.slideTitle : ""}
                </div>
                {
                    props.showAllHandler &&
                    <img
                        className = "d-block d-md-none ms-3"
                        src = {rightArrow}
                        alt = "show all"
                        style = {{cursor: 'pointer'}}
                        onClick = {props.showAllHandler ? props.showAllHandler : null}
                    />
                }
                <div className = "d-none d-md-flex ps-3 justify-content-center align-items-center">
                    {
                        props.tvData && props.showAllHandler && (props.tvData.length > displayCount) ?
                        movedAndMove[0] !== 0 ?
                        <img
                            className='pe-3'
                            src = {leftArrow}
                            alt = "swipe left"
                            style = {{cursor: 'pointer'}}
                            onClick={prevSlide}
                        /> :
                        <img
                            className='pe-3'
                            src = {leftArrowInactive}
                            alt = "swipe left"
                            style = {{opacity: 0.3}}
                        /> : ""
                    }

                    {
                        props.showAllHandler &&
                        <div className = 'text-info text-decoration-underline d-inline-block text-nowrap'
                            role='button'
                            onClick={props.showAllHandler}
                        >
                            show all
                        </div>
                    }

                    {
                        props.tvData && props.showAllHandler && (props.tvData.length > displayCount) ?
                        movedAndMove[0] !== extraSlides ?
                        <img
                            className='ps-3'
                            src = {rightArrow}
                            alt = "swipe right"
                            style = {{cursor: 'pointer'}}
                            onClick={nextSlide}
                        /> :
                        <img
                            className='ps-3'
                            src = {rightArrowInactive}
                            alt = "swipe right"
                            style = {{opacity: 0.3}}
                        /> : ""
                    }
                </div>
            </div>

        }
        <div className = 'col-12 d-flex flex-row justify-content-center align-items-center position-relative px-1 px-lg-0'
          >
              <div>
                {
                    props.tvData && (props.tvData.length > displayCount) ?
                    <div
                        className= {movedAndMove[0] !== 0 ?
                            "position-absolute d-none d-md-flex align-items-center justify-content-center visible":
                            "position-absolute d-none d-md-flex align-items-center justify-content-center hidden"
                            }
                        id="button-prev"
                        role = 'button'
                        onClick={prevSlide}>
                        <img src = {prevArrow} alt = ''
                        />
                    </div> : ""
                }
            <div
            ref={sCWRef}
            className=''
            style={props.tvData.length < displayCount ? {
                width:`${slideWrapperWidth*props.tvData.length + (props.tvData.length-1)*margin}vw`,
                overflow: 'hidden',
            } : {
                width:`${slideWrapperWidth*displayCount + (displayCount-1)*margin}vw`,
                overflow: 'hidden',
            }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
            >
            <SliderContent
                type = {props.type}
                displayCount={displayCount}
                translate={movedAndMove[1]}
                sliderContentWidth={sliderContentWidth}
                slideWrapperWidth={slideWrapperWidth}
                tvData={props.tvData}
                slideClickHandler={props.slideClickHandler}
            />
                  </div>
                {
                    props.tvData && (props.tvData.length > displayCount) ?
                    <div  className= {movedAndMove[0] !== extraSlides ?
                        "position-absolute d-none d-md-flex align-items-center justify-content-center visible" :
                        "position-absolute d-none d-md-flex align-items-center justify-content-center hidden"
                        }
                        role = 'button'
                        id="button-next"
                        onClick={nextSlide}>
                        <img src={nextArrow}
                            alt = ''
                    />
                    </div> : ""
                }
        </div>
        </div>
    </>
  );
}